import { LoginForm } from 'ui/components/buyer/patterns/LoginForm/LoginForm';

/**
 * 買い手企業ログインページ
 */
export const BuyerLogin: React.FC = () => {
    return <LoginForm />;
};
